import React from "react";
import { ExamTimeWay } from "service/exam";
import DateRangePickerUnify from "../components/DateRangePickerUnify";
import DateRangePickerFree from "../components/DateRangePickerFree";
import style from "./index.module.scss";

interface DateRangePickerProps {
    examTimeWay: ExamTimeWay; //考试时间类型
    start: string; //开始时间
    end: string; //结束时间
    onChange: (value: [string, string]) => void;
    disabled: boolean; //禁止点击
}

export default function DateRangePicker(props: DateRangePickerProps) {
    return (
        <div className={style.root}>
            {props.examTimeWay === ExamTimeWay.unify && (
                <DateRangePickerUnify {...props} />
            )}
            {props.examTimeWay === ExamTimeWay.free && (
                <DateRangePickerFree {...props} />
            )}
        </div>
    );
}
